exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LinkContentModal {\n  padding: 1rem;\n}\n.LinkContentModal .ResponsiveGrid {\n  align-items: flex-start;\n}\n.LinkContentModal .ContentCard {\n  border-radius: 1rem;\n}\n.LinkContentModal .ContentCard,\n.LinkContentModal .ContentCard .CoverImage {\n  transition: all 0.2s;\n}\n.LinkContentModal .ContentCard.\\--selected {\n  border: 4px solid #a05dcd;\n}\n.LinkContentModal .ContentCard.\\--selected .CoverImage {\n  border-radius: 0.75rem;\n}\n@media (hover: hover) {\n.LinkContentModal .ResponsiveGrid button:hover .ContentCard:not(.\\--selected) {\n    box-shadow: 0 0 0 4px #e4d2f1;\n}\n}\n", ""]);

// exports
